import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white px-2" }
const _hoisted_2 = { class: "flex flex-col gap-[5px] pt-3 mt-3" }
const _hoisted_3 = { class: "flex justify-center mt-2 text-sm'" }
const _hoisted_4 = { class: "flex w-full pt-16" }
const _hoisted_5 = { class: "text-sm text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_db_input = _resolveComponent("db-input")!
  const _component_db_button = _resolveComponent("db-button")!
  const _component_db_form = _resolveComponent("db-form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_db_form, { class: "flex flex-col gap-[5px]" }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("landing.reset_password.reset_info")), 1),
          _createVNode(_component_db_input, {
            variant: "outline",
            placeholder: _ctx.$t('login.username') + '*',
            label: _ctx.$t('login.username') + '*',
            name: "username",
            ariainvalid: _ctx.errors.username ? 'true' : '',
            modelValue: _ctx.user.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.username) = $event))
          }, null, 8, ["placeholder", "label", "ariainvalid", "modelValue"]),
          _createElementVNode("p", {
            class: _normalizeClass(
            _ctx.errors.username == true && _ctx.errors.password == true
              ? 'flex text-red-700 justify-center mt-2 text-sm'
              : 'hidden'
          )
          }, _toDisplayString(_ctx.$t("login.error")), 3),
          _createVNode(_component_db_button, {
            id: "login",
            variant: "brand-primary",
            "class-list": "w-full mt-2",
            onClick: _ctx.reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("landing.reset_password.submit")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        class: "w-full",
        to: "/login"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_db_button, {
            variant: "tertiary-plain",
            "class-list": "w-full"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("landing.reset_password.cancel")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("landing.required_field")), 1)
      ])
    ])
  ]))
}